var cilMobileLandscape = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M464,96H48a32.036,32.036,0,0,0-32,32V384a32.036,32.036,0,0,0,32,32H464a32.036,32.036,0,0,0,32-32V128A32.036,32.036,0,0,0,464,96ZM48,384V128H96V384.018l-48,0Zm80-256H384V384l-256,.013ZM464,384l-48,0V128h48Z' class='ci-primary'/>"];

export { cilMobileLandscape };

